import * as actionTypes from "Redux/Actions/actionTypes";

const doRegistration = (userdata, callback = () => {}) => ({
  type: actionTypes.REGISTER_REQUEST,
  data: userdata,
  callback,
});

export default doRegistration;
